﻿import Vue from "vue";
import Component from "vue-class-component"
import HotEditableFormManager_ from "./hotEditable/HotEditableFormManager";
import common from "../../common";
import SharedFormManager_ from "./hotEditable/SharedFormManager";
import HotEditableFormLoader_ from "./hotEditable/HotEditableFormLoader";

declare function require(module: string): unknown;
// const HotEditableFormManager = require("./hotEditable/HotEditableFormManager") as HotEditableFormManager_;
// const SharedFormManager = require("./hotEditable/SharedFormManager") as SharedFormManager_;
//const HotEditableFormLoader = require("./hotEditable/HotEditableFormLoader") as HotEditableFormLoader_;

// The @Component decorator indicates the class is a Vue component
@Component
class DonneesReferentiellesVue extends Vue implements common.IHotEditableFormVue {

    $initialData: any;

    shared?: SharedFormManager_;
    formMode = common.HotEditableFormModes.original;
    formManager?: HotEditableFormManager_ | null;
    isVisibleToggleButton = false;

    // Fonction système exécutée automatiquement AVANT le constructeur (!!!)
    beforeCreate() {
        const rootId = (this as any).$initialData.vueElId as string;
        HotEditableFormLoader_.prepareComponentsMarkupFromTarget(true, false, rootId).loadComponentsFromParent(this);

        this.$options.el = '#' + rootId

        this.formManager = new HotEditableFormManager_(this);
        this.shared = new SharedFormManager_(this.formManager);
    }

    // Fonction système exécutée automatiquement lorsque la composante Vue est créée
    created() { }

    // Fonction système exécutée automatiquement lorsque la composante Vue est montée
    mounted() {
    }
}

export = DonneesReferentiellesVue;